import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
const firebaseConfig = {
    apiKey: "AIzaSyA5OWfXhYktWfaJC0I05DqtMuhLv-hl23s",
    authDomain: "calculators-b6448.firebaseapp.com",
    projectId: "calculators-b6448",
    storageBucket: "calculators-b6448.firebasestorage.app",
    messagingSenderId: "1084146467754",
    appId: "1:1084146467754:web:168eec4308370efc5461d3"
};
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
export { db, auth };